export default "__VITE_ASSET__CjC96W2N__"